import React from 'react';
import { ArrowDown } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const Hero = () => {
  const { t } = useTranslation();
  
  const scrollToProperties = () => {
    const propertiesSection = document.getElementById('properties');
    if (propertiesSection) {
      propertiesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full">
      {/* Hero Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1724218041680-a6b87c3c443e"
          alt="Luxury Greek Villa with Infinity Pool"
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      {/* Hero Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="container text-center">
          <h1 className="hero-large mb-6" style={{ fontSize: '56px', fontWeight: 300, letterSpacing: '-0.02em', color: '#C9A961', textShadow: '0 3px 25px rgba(0,0,0,0.6), 0 0 40px rgba(0,0,0,0.4)' }}>
            {t.hero.title}
          </h1>
          <p className="body-large mb-12 max-w-3xl mx-auto" style={{ fontSize: '22px', fontWeight: 400, color: '#FFFFFF', textShadow: '0 2px 20px rgba(0,0,0,0.8), 0 0 30px rgba(0,0,0,0.5)', letterSpacing: '0.02em' }}>
            {t.hero.subtitle}
          </p>
          <button onClick={scrollToProperties} className="btn-primary" style={{ borderColor: '#C9A961', color: '#C9A961', backdropFilter: 'blur(12px)', background: 'rgba(0,0,0,0.3)' }}>
            {t.hero.cta}
          </button>
          
          {/* Scroll Indicator */}
          <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
            <ArrowDown className="w-6 h-6" style={{ color: '#C9A961', filter: 'drop-shadow(0 2px 10px rgba(0,0,0,0.5))' }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;